module.exports = __webpack_public_path__ + "static/img/about-r24nIKT6.3550f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/about-r24nIKT6.png
// module id = LO0/
// module chunks = 16